import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-navbar-style-one',
  templateUrl: './navbar-style-one.component.html',
  styleUrls: ['./navbar-style-one.component.scss']
})
export class NavbarStyleOneComponent implements OnInit {

  avatar = ''
  isLogged = false
  subCategoryID: any
  cartNumber = 0
  currentRoute: string;
  showNavbar: boolean = false
  showCart: boolean = false
  quantityCounter: any

  constructor(private api: ApiService,private url: ActivatedRoute,
    private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
      // console.log('Current Route:', this.currentRoute);
    });
  }

  ngOnInit(): void {
    this.isLogged = (localStorage.getItem('userLogged') == 'true')
    if(this.isLogged){
      const user = JSON.parse(localStorage.getItem('userData'))
      this.avatar = user?.avatar
    }
    setTimeout(() => {
      const quantity = localStorage.getItem('quantity')
      if(quantity){
        this.cartNumber = parseInt(quantity)
      }
    }, 500);

    if( (!this.currentRoute.includes('category') 
      && !this.currentRoute.includes('sub-category')
      && !this.currentRoute.includes('cart')
      && !this.currentRoute.includes('checkout')
      && !this.currentRoute.includes('products-details')
      && !this.currentRoute.includes('login-register')
      && !this.currentRoute.includes('listing')
      && !this.currentRoute.includes('orders')
      && !this.currentRoute.includes('order-details')
      && !this.currentRoute.includes('listing-details')
      && !this.currentRoute.includes('favorites')
      && !this.currentRoute.includes('favorite-products')
      && !this.currentRoute.includes('privacy-policy')
      && !this.currentRoute.includes('terms-condition')
      ) || this.currentRoute.includes('#categorySection')
    ){
      this.showNavbar = true
      console.log(this.currentRoute)
    }else{
      this.showNavbar = false
    }

    if(this.url.snapshot.params['subCatID']){
      this.subCategoryID = this.url.snapshot.params['subCatID'];
      console.log(this.subCategoryID)
      localStorage.setItem('VendorID',this.subCategoryID)
    }

    const token = localStorage.getItem('userToken')
    if(token){
      this.showCart = true
      this.getCart()
    }else{
      this.showCart = false
    }
  }

  refreshCart = true;
  public getCart(){
    this.api.getMyCart().subscribe({
      next: (response) => {
        this.quantityCounter = response.data.map( item => parseInt(item.quantity)).reduce((a, b) => a + b, 0)
        console.log(this.quantityCounter);
      }, error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  logOut(){
    this.api.logout()
    this.isLogged = false
  }

  goBack(){
    history.back()
  }

  isFav: boolean = false;
  toggleFavourite(id: number){
    // $('.heart-btn .fa-haert').toggleClass('fa-regular')
    this.api.addToFav(id).subscribe({
      next: (response) => {
        // console.log(response)
        if(response.success == true){
          this.isFav = !this.isFav
        }
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }
}
